import React, { useEffect, useMemo, useState } from "react";
import { motion } from "framer-motion";
import { ShieldCheck } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { EngineHero } from "@/components/common/EngineHero";
import { EngineFindingsTable } from "@/components/common/FindingDetailSheet";
import { staggerItem } from "@/lib/motion";
import { api } from "@/lib/api";

const RULES = [
    { label: "Missing AUTHORITY-CHECK", category: "Missing AUTHORITY-CHECK" },
    { label: "Weak implementation (wildcards, sy-subrc)", category: "Weak Implementation" },
    { label: "Duplicate validation (≥3 per object)", category: "Duplicate Validation" },
    { label: "Missing S_TCODE for executables", category: "Missing Authorization Object" },
    { label: "SU53 authorization failure traces", category: "SU53 Authorization Failure" },
];

export default function Authorization() {
    const [findings, setFindings] = useState([]);
    useEffect(() => {
        (async () => {
            const { data } = await api.get("/findings", { params: { engine: "authorization" } });
            setFindings(data);
        })();
    }, []);

    const totals = useMemo(
        () => findings.reduce((acc, f) => ({ ...acc, [f.category]: (acc[f.category] || 0) + 1 }), {}),
        [findings],
    );

    return (
        <div className="space-y-6">
            <EngineHero
                testId="auth-engine-hero"
                icon={ShieldCheck}
                engine="Authorization"
                title="ABAP AUTHORITY-CHECK Engineering"
                blurb="Scans every parsed ABAP artifact for missing or weak AUTHORITY-CHECK statements, wildcard field values, duplicated checks, absent sy-subrc evaluation and executables without an S_TCODE gate — then correlates the result against SU53 traces where you have supplied them."
                rules={RULES}
                totals={totals}
            />

            <motion.div variants={staggerItem} initial="initial" animate="animate">
                <Panel eyebrow={`${findings.length} findings`} title="Authorization Findings" testId="auth-findings-panel">
                    <EngineFindingsTable findings={findings} emptyHint="Upload ABAP artifacts and run analysis to populate." />
                </Panel>
            </motion.div>
        </div>
    );
}
